/**
 * NAT-2801 (rule 59) — the five «In corso» bands, in order, and the words for each. One list for
 * the tiles and the export, so the two cannot name a band differently.
 */
import type { ForwardBand } from 'src/types';

export const FORWARD_BANDS: { key: ForwardBand; labelKey: string }[] = [
  { key: 'due_0_15', labelKey: 'scade_0_15' },
  { key: 'due_16_30', labelKey: 'scade_16_30' },
  { key: 'due_31_60', labelKey: 'scade_31_60' },
  { key: 'due_61_90', labelKey: 'scade_61_90' },
  { key: 'due_90_plus', labelKey: 'scade_90_plus' },
];

const LABEL_KEY_OF = Object.fromEntries(FORWARD_BANDS.map((b) => [b.key, b.labelKey])) as Record<
  ForwardBand,
  string
>;

/** The `operativaDashboard` key naming a band; a band this build does not know is left blank. */
export const forwardBandLabelKey = (band: ForwardBand): string | null => LABEL_KEY_OF[band] ?? null;
